import { Button, Separator, VStack } from '@betterment/samba-react';
import { Form, useFormikContext } from 'formik';

import { LegalAccountsContributionsEditor } from './LegalAccountsContributionsEditor';
import { ContributionRateFormValues } from './types';
import { editorValueToString } from './utils';

function formatFormValues(values: ContributionRateFormValues): ContributionRateFormValues {
  return {
    base: {
      traditional: { ...values.base.traditional, text: editorValueToString(values.base.traditional) },
      roth: values.base.roth ? { ...values.base.roth, text: editorValueToString(values.base.roth) } : undefined,
    },
    bonus: values.bonus
      ? {
          traditional: { ...values.bonus.traditional, text: editorValueToString(values.bonus.traditional) },
          roth: values.bonus.roth ? { ...values.bonus.roth, text: editorValueToString(values.bonus.roth) } : undefined,
        }
      : undefined,
  };
}

export const ContributionRatesForm = ({
  hasRothAccount,
  hasBonusRates,
  isSubmitting,
}: {
  hasRothAccount: boolean;
  hasBonusRates: boolean;
  isSubmitting: boolean;
}) => {
  const { values, setValues, submitForm } = useFormikContext<ContributionRateFormValues>();

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    void formatAndSubmit();
  }

  async function formatAndSubmit() {
    await setValues(formatFormValues(values));
    void submitForm();
  }

  return (
    <Form onSubmit={handleSubmit}>
      <VStack css={{ width: 'size.full', gap: 'space.300' }}>
        <LegalAccountsContributionsEditor
          compensationType="base"
          hasRothAccount={hasRothAccount}
          isSubmitting={isSubmitting}
        />
        {hasBonusRates && (
          <>
            <Separator />
            <LegalAccountsContributionsEditor
              compensationType="bonus"
              hasRothAccount={hasRothAccount}
              isSubmitting={isSubmitting}
            />
          </>
        )}
        <Button
          type="submit"
          variant="solidPrimary"
          css={{ width: 'fit-content', px: 'space.800', marginTop: 'space.200' }}
          loading={isSubmitting}
        >
          Update
        </Button>
      </VStack>
    </Form>
  );
};
